<!-- 报关单AI识别：上传/高拍仪拍照 + 识别回填 + 表头与明细一起保存 -->
<template>
    <div>
        <!-- 识别弹窗 -->
        <el-dialog v-dialogDrag title="AI识别" :visible.sync="dialogFormVisible" width="60%"
            :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleClose">
            <!-- 阶段一：上传/拍照 -->
            <template v-if="stage === 'upload'">
                <div class="parse_upload">
                    <el-upload ref="parseUpload" class="parse_upload_item" action="#" :auto-upload="false"
                        accept=".pdf,.jpg,.jpeg,.png,.bmp,.xlsx,.xls" :on-change="handleChange">
                        <el-button plain type="primary" size="mini" icon="el-icon-document">选择文件</el-button>
                    </el-upload>
                    <!-- <el-button plain type="warning" size="mini" class="parse_upload_item" icon="el-icon-camera"
                        @click="openCamera">高拍仪拍照</el-button> -->
                    <el-button plain type="info" size="mini" @click="clearFile" v-if="currentFile">清空</el-button>
                </div>
                <div class="parse_tip">支持 pdf 报关单、图片（jpg/jpeg/png/bmp）或 Excel（xlsx/xls），一次只能识别一个文件</div>
                <!-- 预览 -->
                <div class="parse_preview" v-if="currentFile">
                    <img :src="currentFile.url" class="parse_preview_img" v-if="currentFile.url" alt="报关单">
                    <span class="parse_preview_txt" v-else>{{ currentFile.name }}</span>
                </div>
            </template>
            <!-- 阶段二：出库图片识别出来的文字 + 库存匹配，人工确认后再落库 -->
            <template v-else>
                <div class="parse_tip">识别出来的文字可以直接改；“？”表示没识别出来，必须补全，点“确定”之后才会生成出库单</div>
                <el-input class="parse_text_area" type="textarea" :rows="12" v-model="ocrText"></el-input>
                <!-- 识别提醒：条数多，折叠起来滚动看，不占地方 -->
                <el-collapse v-if="ocrWarnings.length > 0" class="parse_warn">
                    <el-collapse-item :title="'识别提醒（' + ocrWarnings.length + ' 条，可对照上面的“？”核对）'">
                        <div class="parse_warn_list">
                            <p v-for="(w, i) in ocrWarnings" :key="i">{{ i + 1 }}. {{ w }}</p>
                        </div>
                    </el-collapse-item>
                </el-collapse>
                <!-- <el-table :data="stockMatches.stocks" size="mini" border max-height="280" row-key="subRowIndex">
                        <el-table-column field="blNo" title="提单号" width="130" fixed="left"></el-table-column>
                        <el-table-column field="goodsName" title="货物名称" width="140" fixed="left"></el-table-column>
                        <el-table-column field="ownerName" title="货主单位" width="200" fixed="left"></el-table-column>
                        <el-table-column field="customer" title="委托单位" width="200"></el-table-column>
                        <el-table-column field="goodsType" title="货物分类" width="100"></el-table-column>
                        <el-table-column field="isBonded" title="保税类型" width="70"></el-table-column>
                        <el-table-column field="spec" title="规格型号" min-width="150"></el-table-column>
                        <el-table-column field="hsCode" title="海关编码" width="100"></el-table-column>
                        <el-table-column field="invDecNo" title="核注清单号" width="140"></el-table-column>
                        <el-table-column field="cusDeclNo" title="报关单号" width="140"></el-table-column>
                        <el-table-column field="skuNo" title="商品料号" width="140"></el-table-column>
                        <el-table-column field="itemNo" title="项号" width="100"></el-table-column>
                        <el-table-column field="boxNo" title="箱号" width="120"></el-table-column>
                        <el-table-column field="handbook" title="账册编号" width="110"></el-table-column>
                        <el-table-column field="createDate" title="入库日期" width="100" sortable></el-table-column>
                        <el-table-column field="stockDateNum" title="库龄" width="80"></el-table-column>
                        <el-table-column field="ckName" title="仓库" width="100"></el-table-column>
                        <el-table-column field="place" title="库区" width="100"></el-table-column>
                        <el-table-column field="location" title="库位" width="100"></el-table-column>
                        <el-table-column field="netWeight" title="净重" width="100"  align="right"  ></el-table-column>
                        <el-table-column field="qty1" title="件数1" width="100"  align="right" ></el-table-column>
                        <el-table-column field="qty1UnitName" title="件数1单位" width="100"></el-table-column>
                        <el-table-column field="qty2" title="件数2" width="100"  align="right" ></el-table-column>
                        <el-table-column field="qty2UnitName" title="件数2单位" width="100"></el-table-column>
                        <el-table-column field="decPrice" title="申报单价" width="100" align="right"></el-table-column>
                        <el-table-column field="decUnitName" title="申报单位" width="100"></el-table-column>
                        <el-table-column field="decNum" title="申报数量" width="100"  align="right" ></el-table-column>
                        <el-table-column field="decAmount" title="申报金额" width="100"  align="right" ></el-table-column>
                        <el-table-column field="decCurrency" title="币制" width="100" ></el-table-column>
                        <el-table-column field="lawUnitFirstName" title="法定第一单位" width="100"></el-table-column>
                        <el-table-column field="firstNum" title="法定第一数量" width="100"  align="right" ></el-table-column>
                        <el-table-column field="lawUnitSecond" title="法定第二单位" width="100"></el-table-column>
                        <el-table-column field="secondNum" title="法定第二数量" width="100"  align="right" ></el-table-column>
                        <el-table-column field="note" title="备注" width="100" ></el-table-column>
                        <el-table-column field="lotNo" title="LOT号" width="100"  ></el-table-column>
                        <el-table-column field="lotKgs" title="LOT重量" width="80" ></el-table-column>
                        <el-table-column field="lotOrderNo" title="LOT订单号" width="100" ></el-table-column>
                        <el-table-column field="lotMaterialNo" title="LOT物料号" width="100" ></el-table-column>
                </el-table> -->
            </template>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="handleClose">取 消</el-button>
                <el-button v-if="stage === 'upload'" size="mini" type="primary" :loading="parseLoading"
                    @click="startParse">开始识别</el-button>
                <el-button v-else size="mini" type="primary" :loading="applyLoading" @click="applyText">确 定</el-button>
            </span>
        </el-dialog>
        <photoScan ref="PhotoDialog" onlyPhoto @uploadSuccess="handlePhoto"></photoScan>
    </div>
</template>

<script>
import clean from 'lodash-clean';
import photoScan from '@/components/wms/photoScan.vue';
export default {
    name: 'AIRecognition',
    components: {
        photoScan
    },
    // form：父页面的表头对象（同一个引用，保存时读到的就是单证改过的最新值）
    // subList：父页面的计划信息表格数据，行上没有 id 的就是识别进来还没落库的
    props: ['form', 'subList'],
    data() {
        return {
            savedLock: false,   // 本次识别是否已经保存过，等页面刷新
            dialogFormVisible: false, // 识别弹窗显示
            parseLoading: false,      // 识别中
            saveLoading: false,       // 保存中
            currentFile: null,        // 当前选中的文件 {name, raw, isPdf, url}
            // 出库图片识别：识别出来的是文字，要人工确认后才落库
            stage: 'upload',          // upload：上传/拍照阶段；text：文字+库存匹配确认阶段
            ocrText: '',              // textContent，可编辑
            ocrWarnings: [],          // 接口的提醒
            applyLoading: false,      // 落库中
        }
    },
    beforeDestroy() {
        this.releasePreview();
    },
    methods: {
        // ==================== 上传 ====================
        // 打开识别弹窗
        open() {
            this.dialogFormVisible = true;
        },
        // 选择文件：只能有一个，pdf、图片、Excel 三选一
        handleChange(file) {
            const fileExt = file.name.replace(/.+\./, '').toLowerCase(); // .replace(/.+\./, '') 把最后一个点前面的所有字符删掉
            const isPdf = fileExt === 'pdf';
            const isImg = ['jpg', 'jpeg', 'png', 'bmp'].indexOf(fileExt) !== -1;
            // Excel 走单独的识别接口 wms/ai/order/internal/parse
            const isExcel = ['xlsx', 'xls'].indexOf(fileExt) !== -1;
            // 格式校验
            if (!isPdf && !isImg && !isExcel) {
                this.$message.error('只能上传 pdf、jpg/jpeg/png/bmp 或 xlsx/xls 格式的文件！');
                this.resetUpload();
                return;
            }
            // 一次只能有一个文件
            if (this.currentFile) {
                this.$message.warning('只能上传一个文件，请先清空！');
                this.resetUpload();
                return;
            }
            // 大小校验 10M
            if (file.size / 1024 / 1024 >= 10) {
                this.$message.warning('文件大小不能超过10M！');
                this.resetUpload();
                return;
            }
            this.currentFile = {
                name: file.name,
                raw: file.raw,
                isPdf: isPdf,
                isExcel: isExcel,
                // 只有图片需要本地预览地址（blob 开头的），pdf 和 Excel 不预览图片
                url: isImg ? URL.createObjectURL(file.raw) : ''
            };
            // 清掉 el-upload 内部列表，不然同一个文件选第二次不触发
            this.resetUpload();
        },
        // 清空 el-upload 内部列表，不影响 currentFile
        resetUpload() {
            this.$nextTick(() => {
                if (this.$refs.parseUpload) {
                    this.$refs.parseUpload.clearFiles();
                }
            });
        },
        // 清空当前文件
        clearFile() {
            this.releasePreview();
            this.currentFile = null;
            this.resetUpload();
        },
        // 释放预览地址
        releasePreview() {
            if (this.currentFile && this.currentFile.url && this.currentFile.url.indexOf('blob:') === 0) {
                URL.revokeObjectURL(this.currentFile.url);
            }
        },

         // ==================== 高拍仪 ====================
        // 打开高拍仪，写法和 inWarehouse 里的 openPhotoScan 保持一致
        openCamera() {
            if (this.currentFile) {
                this.$message.warning('只能上传一个文件，请先清空！');
                return;
            }
            this.$refs.PhotoDialog.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.PhotoDialog.getCompetence();
            })
        },
        // 拍完照：只取第一张，一次识别一个文件
        handlePhoto(fileList) {
            if (!fileList || fileList.length === 0) {
                return;
            }
            if (fileList.length > 1) {
                this.$message.warning('一次只识别一张，已取第一张！');
            }
            // 拍照出来的是图片，走图片识别接口
            this.currentFile = {
                name: fileList[0].name,
                raw: fileList[0].raw,
                isPdf: false,
                isExcel: false,
                url: fileList[0].url
            };
            this.$message.success('拍照成功，请点开始识别');
        },

        // ==================== 识别 ====================
        // 开始识别：pdf、图片、Excel 分别是三个接口，返回结构一样
        startParse() {
            if (!this.currentFile) {
                this.$message.warning('请先上传文件或拍照！');
                return;
            }
            const formData = new FormData();
            // 单个文件，字段名 file
            formData.append('file', this.currentFile.raw);

            const isImgFile = !this.currentFile.isExcel && !this.currentFile.isPdf;
            // 出入库类型跟父页面表头走
            const taskType = (this.form && this.form.taskType) || '入库';

            let request;
            if (this.currentFile.isExcel) {
                // Excel（xlsx/xls）走内部委托单识别接口，query 必须带 taskType（跟着父页面表头，默认入库）
                request = taskType === '出库'
                    ? this.$api.wmsAiParseOrderOutApply({ taskType: taskType }, formData)   // 出库 Excel
                    : this.$api.wmsAiParseOrderInternal({ taskType: taskType }, formData);  // 入库 Excel
            } else if (this.currentFile.isPdf) {
                request = taskType === '出库'
                    ? this.$api.wmsAiParseOrderDeclOutApply(formData)   // 出库 pdf
                    : this.$api.wmsAiParseDeclPdf(formData);  // 入库 pdf
            } else {
                // 图片
                if (taskType === '出库') {
                    request = this.$api.wmsAiParseDeclTextOutParse(formData);
                }else{
                    request = this.$api.getCkNamesBy()
                    .catch(() => [])                       // 取不到仓库也不影响识别
                    .then(list => {
                        const ckName = (list && list[0]) ||  '';
                        return this.$api.wmsAiParseExternalInParse(ckName,formData);
                    });
                }
            } 
            
            this.parseLoading = true;
            request.then(res => {
                // 图片：先让用户核对/补全文字，点“确定”才调落库接口
                if (isImgFile) {
                    this.ocrText = (res && res.textContent) || '';
                    // this.stockMatches = (res && res.stockMatches) || []
                    this.ocrWarnings = (res && res.warnings) || [];
                    this.stage = 'text';   // 切到确认阶段，弹窗不关
                    return;
                }
                // 如果是出库则直接查询详情
                if (taskType === '出库') {
                    const taskMainId = res && (res.taskMainId || res.id);
                    if (!taskMainId) {
                        this.$message.error('识别成功但没返回 taskMainId，请确认返回字段');
                        return;                       // 不关弹窗，方便排查
                    }
                    this.$emit('taskSaved', taskMainId);   // 新增事件
                    this.$message.success('识别成功');
                    this.handleClose();
                    return;                            // 出库不再走下面入库那套
                }
                // 入库识别结果回填到页面，弹窗自动关闭，后面由单证核对
                this.$emit('fill', res);
                this.savedLock = false;   // ← 新的识别开始了，解锁
                this.$message.success('识别成功');
                this.handleClose();
            }).finally(() => {
                this.parseLoading = false;
            })
        },

        // 文字确认阶段的“确定”：校验 → 落库 → 拿 taskMainId 交给父页面查详情
        applyText() {
            const text = (this.ocrText || '').trim();
            if (!text) {
                this.$message.warning('识别内容不能为空！');
                return;
            }
            // 没识别出来的地方是“？”，必须人工补全，半角全角都拦
            const leftCount = (text.match(/[?？]/g) || []).length;
            if (leftCount > 0) {
                this.$message.error('还有 ' + leftCount + ' 处“？”没有填写完整，请补全后再确定！');
                return;
            }
            if (this.applyLoading) {
                return;
            }
            this.applyLoading = true;
            const taskType = (this.form && this.form.taskType) || '入库';
            const applyTask = taskType === '出库'
                ? this.$api.wmsAiParseDeclTextOutApply({ text: this.ocrText })
                : this.$api.wmsAiParseDeclExternalInApply({ text: this.ocrText });
            applyTask.then(res => {
                // 出库
                if( taskType === '出库' ){
                    const taskMainId = res && (res.taskMainId || res.id);
                    if (!taskMainId) {
                        this.$message.error('保存成功但没返回 taskMainId，请确认返回字段');
                        return;                       // 不关弹窗，方便排查
                    }
                    this.$emit('taskSaved', taskMainId);
                    this.$message.success('识别成功');
                    this.doClose();
                    return
                }else{
                    // 入库需用户手动保存
                     if (!res || (!res.taskMain && !res.taskSub)) {
                        this.$message.error('没有返回识别内容，请确认返回字段');
                        return;                      // 不关弹窗
                    }
                    this.savedLock = false;
                    this.$emit('fill', res);
                    this.$message.success('识别成功');
                    this.doClose();
                }
                
            }).finally(() => {
                this.applyLoading = false;
            })
        },

        // 关闭识别弹窗：确认阶段先问一下，避免改好的内容还没落库就关了
        handleClose() {
            if (this.stage === 'text') {
                this.$confirm('识别内容还没有生成出库单，确定关闭吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.doClose();
                }).catch(() => {
                    // 用户点了取消，什么都不做
                });
                return;
            }
            this.doClose();
        },
        // 真正关闭并复位
        doClose() {
            this.clearFile();
            this.parseLoading = false;
            this.applyLoading = false;
            this.stage = 'upload';
            this.ocrText = '';
            this.ocrWarnings = [];
            this.dialogFormVisible = false;
        },

        // ==================== 保存 ====================
        // 给父页面判断：表格里有没有识别进来还没落库的明细行
        hasPending() {
            if (this.form && this.form.taskType === '出库') return false;
            // 刚保存过，等父页面刷新完表格再判断
            if (this.savedLock) {
                return false;
            }
            const list = this.subList || [];
            return list.some(row => !row.id);
        },
        // 保存：入库单号 → 表头 → 识别出来的明细，串起来一次提交
        saveAll() {
            if (!this.form || this.form.taskType === '出库') { return }  // 出库后端已保存，前端不再提交
            if (!this.form) {
                return;
            }
            if (this.saveLoading) {          // ← 新增：正在保存中，直接忽略
                return;
            }
            this.saveLoading = true;
            // 没有入库单号先取号，和页面原来的保存顺序一致
            const billNoTask = this.form.billNo
                ? Promise.resolve(this.form.billNo)
                : this.$api.getWMSBillNo('RK');
            billNoTask.then(billNo => {
                this.form.billNo = billNo;
                // 第一步：保存表头
                return this.$api.saveMain(this.form);
            }).then( async id => {
                 if (!id) {                       // ← 新增：拿不到主键就不要再往下走
                    this.$message.error('表头保存未返回主键，请刷新页面确认后再操作');
                    throw new Error('saveMain 未返回 id');
                }
                this.form.id = id;               // ← 新增：立即写回，避免重复新建
                // 第二步：保存表格里还没有主键的明细行（识别进来的）
                const newRows = (this.subList || []).filter(row => !row.id);
                if (newRows.length === 0) {
                    return id;
                }

                for (const row of newRows) {
                    const newId = await this.$api.insOneRecordWMSTask(this.buildSubParams(row, id));
                    if (newId) {
                        row.id = newId;          // 写回，避免重复插入
                    }
                }
                return id;
            }).then(id => {
                this.savedLock = true;   // ← 加这行
                // 交给父页面收尾：存id + 刷新表格
                this.$emit('saved', id);
            }).catch(() => {
                // 接口错误 request.js 已经统一提示，这里只保证 loading 能关掉
            }).finally(() => {
                this.saveLoading = false;
            })
        },
        // 组装明细提交参数，和页面新增货物时提交的格式保持一致
        buildSubParams(row, interId) {
            const blNo = this.form.blNo;
            return clean({
                interId: interId,
                rowStatus: '新建',
                blNo: blNo,
                skuNo: blNo,
                taskType: '入库',
                itemNo: row.itemNo,
                goodsName: row.goodsName,
                hsCode: row.hsCode,
                goodsType: row.goodsType,          // 货物类别
                spec: row.spec,
                packageType: row.packageType,
                qty1: row.qty1,
                qty1Unit: row.qty1Unit,
                qty2: row.qty2,                    // ← 补
                qty2Unit: row.qty2Unit,            // ← 补
                netWeight: row.netWeight,
                vol: row.vol,                      // ← 补
                decPrice: row.decPrice,
                decAmount: row.decAmount,
                decNum: row.decNum,                // ← 补：申报数量
                decUnit: row.decUnit,              // ← 补：申报单位
                decCurrency: row.decCurrency,
                originCountry: row.originCountry,
                firstNum: row.firstNum,            // ← 补：法一数量
                lawUnitFirst: row.lawUnitFirst,    // ← 补：法一单位
                secondNum: row.secondNum,          // ← 补：法二数量
                lawUnitSecond: row.lawUnitSecond,  // ← 补：法二单位
                boxNo: row.boxNo,                  // ← 补：箱号
                sealNo: row.sealNo,                // ← 补：铅封号
                taskNote: row.taskNote             // ← 补：作业备注
            })
        }
    }
}
</script>

<style lang="css" scoped>
.parse_upload {
    display: flex;
    align-items: center;
}

.parse_upload .parse_upload_item {
    margin-right: 10px;
}

.parse_tip {
    margin-top: 10px;
    color: #909399;
    font-size: 12px;
}

.parse_preview {
    margin-top: 10px;
}

.parse_preview_img {
    max-width: 240px;
    max-height: 240px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
}

.parse_preview_txt {
    color: #606266;
    font-size: 12px;
}

.parse_text_area {
    margin-top: 6px;
}

.parse_warn {
    margin-top: 8px;
}

.parse_warn_list {
    max-height: 140px;
    overflow-y: auto;
}

.parse_warn_list p {
    margin: 0 0 4px;
    font-size: 12px;
    line-height: 18px;
    color: #e6a23c;
}

</style>
